class JSONFileHandler {

	static getJsonFile(type){
		let data=[];
		switch (type) {
		    case 'recent':
		    	data=require('../data/stubs/api/search/1.0/recent-search/success.json');
		        break;
		    case 'position':
		    	const jsonString='[{"pfId":"8083636.01","psPosId":1105828,"psDesc":"AIA GROUP LTD","psAstCls":1},{"pfId":"8083636.01","psPosId":2139642,"psDesc":"AIA GROUP LTD display","psAstCls":2},{"pfId":"8083637.01","psPosId":2139643,"psDesc":"AIA GROUP LTD display 1","psAstCls":3}]';
		    	data=JSON.parse(jsonString);
		    	break;
				case 'Positions':
			    	data = require('../data/stubs/api/downloads/1.0/positions/success.json');
			    break;
				case 'Transaction':
			    	data = require('../data/stubs/api/downloads/1.0/transaction/success.json');
			    break;
		    default:
		    	data=[];
		 }
		return data;
	}


}

export default JSONFileHandler;
